<template>
  <div>
    <client-profile v-if="isClient()" />

    <official-profile v-else-if="isOfficial()" :editProfileId="editdId" />

    <partner-profile v-else :editProfileId="editdId" />
  </div>
</template>

<script>
import { isClient, isOfficial, SessionStorage } from '@witkac/kartamiejska-shared';
import { mapState } from 'vuex';

import store from '@/store/store';
import ClientProfile from '@/views/client/Profile.vue';
import OfficialProfile from '@/views/officials/Profile.vue';
import PartnerProfile from '@/views/partners/Profile.vue';

/**
 * @vuese
 * Profil
 * @group Profil
 */
export default {
  components: { ClientProfile, OfficialProfile, PartnerProfile },

  computed: {
    editdId() {
      return parseInt(localStorage.getItem(SessionStorage.PROFILE_ID), 10);
    }
  },

  methods: {
    /**
     * @vuese
     * Sprawdza, czy zalogowany użytkownik jest klientem
     */
    isClient,
    // @vuese
    // Sprawdza, czy zalogowany użytkownik jest operatorem
    isOfficial
  }
};
</script>
